/**
 * [delay Set a delay with promise and timeout]
 * @param  {[Number]} time               [in miliseconds]
 * @return {[Promise]}      [Delay promise]
 */
export const delay = time => new Promise(resolve => setTimeout(resolve, time))
